import React, { useEffect, useState } from "react";
import { IKeyVal } from "../shared/Password";
import PropertyRowEdit from "./PropertyRowEdit";
import _ from "lodash";

export interface IPropertyListProps {
    passwordId:string
    data:IKeyVal[]
    onUpdate:(index:number,key:string,val:string) => void
    onDelete:(index:number) => void
    onDirty:() => void
}
export default function PropertyListEdit(props:IPropertyListProps) {
    const {data,passwordId} = props
    const onDelete = (index:number) => () => props.onDelete(index)
    const list = data.map((keyval,i) => <PropertyRowEdit key={keyval.key + "." + i} passwordId={passwordId} index={i} name={keyval.key} value={keyval.val} onDelete={onDelete(i)} onUpdate={props.onUpdate} onDirty={props.onDirty}/>)
    return <div className="properties">
        {list}
        <PropertyRowEdit key={"empty."+data.length} passwordId={passwordId} index={-1} onUpdate={props.onUpdate} onDirty={props.onDirty}/>
    </div>
}